import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AssignmentChangeSubstituteResultModel } from '../../models/assignment-change-substitute-result.model';
import { AssignmentTakeoverModel } from '../../models/assignment-takeover.model';
import { AssignmentsTakeoverPostModel } from '../../models/assignments-takeover-post.model';
import { AssignmentsService } from '../../services/assignments.service';

@Component({
    selector: 'app-open-assignments-modal',
    templateUrl: './open-assignments-modal.component.html',
    styleUrl: './open-assignments-modal.component.scss'
})
export class OpenAssignmentsModalComponent implements OnInit {
    @Input() selectedAssignmentsCount: number = 0;
    @Output() onSuccess = new EventEmitter<boolean>();
    isCloseOnly: boolean = false;
    takeoverAssignments: AssignmentTakeoverModel[] = [];

    isLoading: boolean = false;

    constructor(
        private assignmentService: AssignmentsService
    ) { }

    ngOnInit(): void {
        this.sortSelectedAssignments();
    }

    public sendTakeoverAssignments(takeoverAssignments: AssignmentsTakeoverPostModel): void {
        this.assignmentService.sendTakeoverAssignments(takeoverAssignments).subscribe(
            (response: AssignmentChangeSubstituteResultModel[]) => {
                this.updateTakeoverResults(response);
                this.onSuccess.emit(true);
                this.isLoading = false;
            }
        );

        this.isCloseOnly = true;
    }

    protected setTakeoverModel(): void {
        this.isLoading = true;
        const postModel = this.createAssignmentsTakeoverModel();
        this.sendTakeoverAssignments(postModel);
    }

    protected isAssignmentOnSameDay(from: Date | undefined, to: Date | undefined): boolean {
        if (!from || !to) return false;
        return new Date(from).toDateString() === new Date(to).toDateString();
    }

    private updateTakeoverResults(results: AssignmentChangeSubstituteResultModel[]): void {
        results.forEach(result => {
            const match = this.takeoverAssignments.find(
                t => t.assignment.eventLessonId === result.eventLessonId && t.isSuccess == null
            );

            if (match) {
                match.isSuccess = result.isSuccessful;
                match.errorMessage = result.errorMessage;
            }
        });
    }

    private createAssignmentsTakeoverModel(): AssignmentsTakeoverPostModel {
        return {
            assignments: this.takeoverAssignments.map(t => ({
                assignmentId: t.assignment.id,
                eventLessonId: t.assignment.eventLessonId
            }))
        };
    }

    private sortSelectedAssignments(): void {
        this.takeoverAssignments.sort((a, b) => {
            const dateA = a.assignment.from ? new Date(a.assignment.from).getTime() : 0;
            const dateB = b.assignment.to ? new Date(b.assignment.to).getTime() : 0;
            return dateA - dateB;
        });
    }
}
